const SERVICE = "000018f0-0000-1000-8000-00805f9b34fb";
const WRITE = "00002af1-0000-1000-8000-00805f9b34fb";

let savedDevice;

export const printReceipt = async (commands) => {
  try {
    if (!savedDevice) {
      const device = await navigator.bluetooth.requestDevice({
        filters: [{ services: [SERVICE] }],
      });
      savedDevice = device;
    }

    const server = await savedDevice.gatt.connect();
    const service = await server.getPrimaryService(SERVICE);
    const channel = await service.getCharacteristic(WRITE);

    const chunkSize = 200; // Bluetooth limit

    for (const data of commands) {
      for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);
        await channel.writeValue(chunk);
        await new Promise((resolve) => setTimeout(resolve, 50));
      }
    }

    await savedDevice.gatt.disconnect();
  } catch (error) {
    window.alert(`printing issues: ${error.message}`);
  }
};
